import React, { Component } from 'react';
import LoginRegisterTab from '../../components/Auth/LoginRegisterTab';
import LoginRegisterSidebar from './LoginRegisterSidebar';

class Register extends Component {
    render() {
        return (
            <div className='login_register_page register_page'>
                <LoginRegisterSidebar/>
                <LoginRegisterTab tab="register"/>
            </div>
        );
    }
}

export default Register;